// People's sub-tabs (REQ-241, ADR-115, SCR-591): Users · Teams · Invites, the one table both
// shells render. The row reads the surface: staff invite per installation on SCR-583, so the
// billing admin's People has no Invites sub-tab; the proxy's (the customer surface) has all three.
import type { Surface } from "../../api/org-context";
import { firstVisible, type SubTabDef } from "../../primitives/subtabs";

export type PeopleSubtab = "users" | "teams" | "invites";

export const PEOPLE_SUBTABS: readonly (SubTabDef<Surface> & { id: PeopleSubtab })[] = [
  { id: "users", label: "Users", visible: () => true },
  { id: "teams", label: "Teams", visible: () => true },
  { id: "invites", label: "Invites", visible: (surface) => surface === "customer" },
];

/**
 * The sub-tab a People route shows: the first visible one at the bare URL (`subtab` undefined),
 * the one named when `surface` may open it, and null for an unknown or hidden one (the shell
 * shows "not found").
 *
 * peopleSubtab(undefined, "staff") === "users"; peopleSubtab("invites", "staff") === null
 */
export function peopleSubtab(subtab: string | undefined, surface: Surface): PeopleSubtab | null {
  const id = subtab ?? firstVisible(PEOPLE_SUBTABS, surface);
  return PEOPLE_SUBTABS.find((def) => def.id === id && def.visible(surface))?.id ?? null;
}
